import { Box, Grid2, Typography } from "@mui/material";
import TextReadMoreLess from "./TextReadMoreLess";
import { PrimaryTooltip } from "../StyledComponent";
import { convertAndGetTimeStampInRequiredFormat } from "../../Helper/DatePicker/DateConverter";
import { useBaseEntityInfo } from "../../Hooks/usePagesContent";
import { getStatusDisplay, NON_OPERATIONAL } from "../../Helper/OperationalStatus/statusOptions";

const SingleEntityCurrentStatus = ({ deviceId, reasonOptions, data }) => {

    const { status, statusTime, reasonForNonOperational, comment, updatedBy } = data
    const { baseEntityTypeIDLable } = useBaseEntityInfo();

    const showReasonForNonOperational = status === NON_OPERATIONAL;
    const { label: statusLabel, color: statusColor } = getStatusDisplay(status);
    let displayStatusTime = statusTime;
    if (statusTime) {
        displayStatusTime = convertAndGetTimeStampInRequiredFormat(statusTime, "DD MMM'YY, hh:mm A")
    }

    return (
        <Box sx={{ bgcolor: '#F9F9F9', borderRadius: 2, px: 2, py: 1.5, mb: 1 }}>
            <Box sx={{ mb: 1 }}>
                <Typography variant="fw600s16c000000" sx={{ lineHeight: '24px' }}>Current Status Details</Typography>
            </Box>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>{baseEntityTypeIDLable}</Typography>
                <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>{deviceId}</Typography>
            </Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500 }}>Current Status:</Typography>
                <Grid2 container gap={0.5} alignItems={'center'}>
                    <Typography variant="fw400s14c000000" sx={{ lineHeight: '24px', fontWeight: 500, color: statusColor }}>{statusLabel}</Typography>
                    {displayStatusTime && (
                        <PrimaryTooltip title="Last Updated" position="bottom">
                            <Typography variant="fw400s12c686868">({displayStatusTime})</Typography>
                        </PrimaryTooltip>
                    )}
                </Grid2>
            </Grid2>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>Updated By:</Typography>
                <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px', fontWeight: 400 }}>{updatedBy || '-'}</Typography>
            </Grid2>
            {showReasonForNonOperational && (
                <Grid2 container justifyContent={'space-between'} alignItems={'center'} mb={0.5}>
                    <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>Reason:</Typography>
                    <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px', fontWeight: 400 }}>{reasonOptions?.[reasonForNonOperational] || ''}</Typography>
                </Grid2>
            )}
            <Grid2 container flexDirection={comment ? 'column' : 'row'} justifyContent={'space-between'} mb={0.5}>
                <Typography variant="fw500s14c2E2E2E" sx={{ lineHeight: '24px' }}>Comments:</Typography>
                <TextReadMoreLess text={comment || '-'} />
            </Grid2>
        </Box>
    )
}

export default SingleEntityCurrentStatus;
